var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDockerFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#272627",
    d: "M23.77 11.08a5.12 5.12 0 0 0-2.41-.77 2.7 2.7 0 0 0-.44 0 4.24 4.24 0 0 0-1.64-2.26.5.5 0 0 0-.64.07 4.06 4.06 0 0 0-.72 3.28.52.52 0 0 1-.13.41.45.45 0 0 1-.34.15H17V9.5a.5.5 0 0 0-.5-.5H14V3.5a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5V6H4.5a.5.5 0 0 0-.5.5V9H1.5a.5.5 0 0 0-.5.5V12H.5a.5.5 0 0 0-.5.5C0 20.17 5.59 21 8 21a14.29 14.29 0 0 0 12.38-7.08 5.13 5.13 0 0 0 3.55-2.17.5.5 0 0 0-.16-.67zM16 12h-2v-2h2zM5 12v-2h2v2zm3 0v-2h2v2zm5-5v2h-2V7zm-2 5v-2h2v2zm0-8h2v2h-2zm-1 5H8V7h2zM5 7h2v2H5zm-3 3h2v2H2zm3 7a1 1 0 1 1 1-1 1 1 0 0 1-1 1z",
    opacity: 1,
    "data-original": "#303c42",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDockerFilled);
export default __webpack_public_path__ + "static/media/docker-filled.4302c938896885f3927e4fb04857a813.svg";
export { ForwardRef as ReactComponent };